import React, { useEffect, useState, Fragment } from 'react';
import Header from './Header';
import DefaultSidebar from './Sidebar'
import axios from 'axios';
import { Link } from 'react-router-dom';
import ModalCreateAnnuaireAltaClient from './ModalCreateAnnuaireAltaClient'



function AnnuaireAltaClient() {

    // console.log(`HERE id is ${idChoose}`);
    const [data, setDate] = useState([])
    const [device, setDevice] = useState([])
    const [search, setSearch] = useState('');
    // const [open, setOpen] = useState('block')
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_IP}:${process.env.REACT_APP_PORT}/get_client_annuaire_alta`)
            .then(res => {
                console.log(res.data);
                setDate(res.data)
            }).catch(err => console.log(err))
    }, [])

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_IP}:${process.env.REACT_APP_PORT}/get_device_annuaire_alta`)
            .then(res => {
                setDevice(res.data)
            }).catch(err => console.log(err))
    }, [])

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    const filteredClients = data.filter(client => {
        const relatedDevices = device.filter(d => d.id_client === client.id_client);
    
        const clientMatch = client.nom_client?.toLowerCase().includes(search.toLowerCase());
        const deviceMatch = relatedDevices.some(d =>
            d.type?.toLowerCase().includes(search.toLowerCase()) ||
            d.name?.toLowerCase().includes(search.toLowerCase()) ||
            d.date?.toLowerCase().includes(search.toLowerCase()) ||
            d.id_anydesk?.toLowerCase().includes(search.toLowerCase()) ||
            d.password_anydesk?.toLowerCase().includes(search.toLowerCase()) ||
            d.id_room_pdv?.toLowerCase().includes(search.toLowerCase()) ||
            d.remarque?.toLowerCase().includes(search.toLowerCase())
        );
    
        return search === '' || clientMatch || deviceMatch;
    })

    const arr = filteredClients.map((client, index) => {
            return (
                <Link to={`/annuairealta/${client.id_client}`} key={index}>
                    <div className="block max-w-sm p-6 bg-white border border-slate-200 rounded-lg shadow hover:bg-slate-100 dark:bg-slate-800 dark:border-slate-700 dark:hover:bg-slate-700">
                        <h5 className="mb-2 text-2xl font-bold tracking-tight text-slate-900 dark:text-white">{client.nom_client}</h5>
                    </div>
                </Link>
            )
        })
    return (
        <Fragment>

            <div>
                {/* <Header /> */}
                <div className='max-w-md flex items-center text-center mx-auto my-2 gap-2'>
                    {/* <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8 absolute left-1 cursor-pointer" onClick={() => setOpen(open === `hidden` ? 'block' : 'hidden')} >
                        <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
                    </svg> */}
                    <div className="relative flex items-left w-full h-9 rounded-lg focus-within:shadow-lg bg-slate-700 overflow-hidden">
                        <div className="grid place-items-center h-full w-12 text-slate-50">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                            </svg>
                        </div>

                        <input
                            className="h-full w-full outline-none text-white pr-2 bg-slate-700 placeholder-slate-50"
                            type="text"
                            id="search"
                            placeholder="Search something.."
                            onChange={(e) => setSearch(e.target.value)}
                        />
                    </div>
                </div>
                <main className="flex flex-row mt-4">
                    {/* <DefaultSidebar isOpen={open} /> */}
                    <div className="grid lg:grid-cols-5 gap-2 text-center mx-auto mb-2">
                        {arr}
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-10 h-10 fixed bottom-16 right-6 cursor-pointer" onClick={() => scrollToTop()}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M15 11.25l-3-3m0 0l-3 3m3-3v7.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-10 h-10 fixed bottom-6 right-6 cursor-pointer" onClick={() => setShowModal(true)} >
                        <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    </div>
                </main>
            </div>
            <ModalCreateAnnuaireAltaClient isVisible={showModal} onClose={() => setShowModal(false)} />
        </Fragment>

    )
}

export default AnnuaireAltaClient;